import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getFeatures, getSimulation } from '../client';
import { computeResults } from '../earnings';
import { useTeam } from './useTeam';
import { useSimulationId } from './useSimulationId';

export function useSimulationResults() {
  const simId = useSimulationId();
  const team = useTeam();

  const simQuery = useQuery({
    queryKey: ['simulation', simId],
    queryFn: () => getSimulation({ path: { sim_id: simId }, throwOnError: true }).then(({ data }) => data),
    refetchInterval: 30_000,
  });

  const featuresQuery = useQuery({
    queryKey: ['features', simId],
    queryFn: () => getFeatures({ path: { sim_id: simId }, throwOnError: true }).then(({ data }) => data),
    refetchInterval: 30_000,
  });

  const results = useMemo(() => {
    if (!simQuery.data || !featuresQuery.data) return undefined;
    const r = computeResults(featuresQuery.data, team.name, simQuery.data.simulation_time_s);
    return {
      tasks_completed: r.tasksCompleted,
      features_completed: r.featuresCompleted,
      earned: r.earned,
      earnings_per_second: r.earningsPerSecond,
      team_name: team.name,
    };
  }, [simQuery.data, featuresQuery.data, team.name]);

  return {
    data: results,
    isLoading: simQuery.isLoading || featuresQuery.isLoading,
    isError: simQuery.isError || featuresQuery.isError,
    error: simQuery.error || featuresQuery.error,
  };
}
